import { render, staticRenderFns } from "./WhoIAmLinks.vue?vue&type=template&id=6f8faa78&lang=pug&"
import script from "./WhoIAmLinks.vue?vue&type=script&lang=js&"
export * from "./WhoIAmLinks.vue?vue&type=script&lang=js&"
import style0 from "./WhoIAmLinks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports